/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/array/ArrayToHEX.ts
 * @create:      2025-06-26 15:59:16.616
 * @modify:      2025-07-11 21:19:12.780
 * @version:     6.0.0
 * @times:       6
 * @lines:       49
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Converts a sequence of numbers into a single hexadecimal string.
 *
 * Each number in the input is treated as an unsigned 32-bit integer,
 * converted to its hexadecimal representation, and padded to 8 characters with leading zeros.
 * The resulting hexadecimal strings are concatenated together.
 *
 * @param array - A sequence of numbers to convert to hexadecimal.
 * @returns A concatenated hexadecimal string representation of the input numbers.
 * 
 * @since 4.0.0
 * @version 2025-06-27
 */
export function ArrayToHEX(...array: number[]) {
    return array.map(p => (p >>> 0).toString(16).padStart(8, "0")).join("");
}
